import {
    buildSchema, buildProperty, EntityCallbacks
} from "@camberi/firecms";

export const sessionsSchema = buildSchema({
    name: "Sessions",
    properties: {
        sessionName: {
            title: "Session Name",
            dataType: "string",
            validation: { required: true },
        },
        coachReference: buildProperty({
            title: "Coach",
            dataType: "reference",
            path: "coaches",
            previewProperties: ["firstName", "lastName", "isApproved"],
            // validation: { required: true },
        }),
        description: {
            title: "Description",
            dataType: "string"
        },
        workoutCategoryReference: buildProperty({
            title: "Category",
            dataType: "reference",
            path: "workout_categories",
            previewProperties: [],
            validation: { required: true },
        }),

        startDateTimeStamp: {
            title: "Start Date",
            dataType: "timestamp",
            // validation: { required: true },
        },
        expectedDurationInMinutes: {
            title: "Duration (In Minutes)",
            dataType: "number",
            validation: { required: true },
        },
        isFree: buildProperty({
            title: "Is Free",
            dataType: "boolean",
        }),
        clientReference: buildProperty({
            title: "Client",
            dataType: "reference",
            path: "users",
            previewProperties: ["firstName", "lastName", "isApproved"],
            // validation: { required: true },
        }),
        sessionStatus: buildProperty({
            title: "Session Status",
            dataType: "string",
            config: {
                enumValues: {
                    pending: "Pending",
                    accepted: "Accepted",
                    rejected: "Rejected",
                }
            },
            disabled: true
        }),
        category: {
            title: "Category",
            description: "Category Details",
            dataType: "map",
            properties: {
                categoryName: {
                    title: "Category",
                    dataType: "string"
                }
            },
            readOnly: true
        },

        channelName: {
            title: "Channel Name",
            dataType: "string",
            readOnly: true
        },
        savedVideoUrl: {
            title: "Saved Video Url",
            dataType: "string",
            config: {
                storageMeta: {
                    mediaType: "video",
                    storagePath: "videos",
                    acceptedFiles: ["video/*"],
                    storeUrl: true,
                    metadata: {
                        cacheControl: "max-age=1000000"
                    }
                }
            },
            disabled: true,
            readOnly: true
        },
        startedAt: {
            title: "Started At",
            dataType: "timestamp",
            disabled: true,
            readOnly: true
        },
        startDate: {
            title: "Start Date",
            dataType: "string",
            disabled: true,
            readOnly: true
        },
        endedAt: {
            title: "Ended At",
            dataType: "timestamp",
            disabled: true,
            readOnly: true
        },

        coach: {
            title: "Coach Name",
            description: "Coach Details",
            // dataType: "reference",
            // path: "coaches",
            // previewProperties: ["firstName", "lastName"]
            dataType: "map",
            properties: {
                firstName: {
                    title: "firstName",
                    dataType: "string",
                    disabled: true
                },
                lastName: {
                    title: "lastName",
                    dataType: "string",
                    disabled: true
                },
            },
            disabled: true,
            readOnly: true
        },

        externalLiveUrl: {
            title: "External Live URL",
            dataType: "string",
            disabled: true,
            readOnly: true
        },
        hasEnded: {
            title: "Has Ended",
            dataType: "boolean",
            disabled: true,
            readOnly: true
        },
        savedVideo: {
            title: "Saved Video",
            dataType: "boolean",
            disabled: true,
            readOnly: true
        },
        isArchived: {
            title: "Is Archived",
            dataType: "boolean",
            disabled: true,
            readOnly: true
        },
        createdBy: {
            title: "Created By",
            dataType: "string",
            disabled: true,
            readOnly: true
        },
        isOneToOne: {
            title: "Is One to One",
            dataType: "boolean",

        },
        status: {
            title: "Status",
            dataType: "string",
            config: {
                enumValues: {
                    waiting: "Waiting",
                    open: "Open",
                    live: "Live",
                    finished: "Finished",
                    closed: "Closed",
                }
            },
            disabled: true,
            readOnly: true
        },
        sessionType: buildProperty({
            title: "Session Type",
            validation: { required: true },
            dataType: "number",
            columnWidth: 140,
            config: {
                enumValues: {
                    1: "Live",
                    0: "Test",
                }
            },
            disabled: true,
            readOnly: true
        }),

    },
    defaultValues: {
        sessionType: 1,
        isOneToOne: true,
        sessionStatus: "pending",
        // createdBy: useAuthController.
    }
});

export const sessionCallbacks: EntityCallbacks = {
    onPreSave: ({
        schema,
        path,
        entityId,
        values,
        status,
        context
    }) => {
        values.createdBy = context.authController.user.uid.toString();
        return values;
    },
};
